import { NavLink } from "react-router-dom";
import { StyledLogo } from "../Navmenu.styled";
import logo from "assets/images/logo.png";


function Logo() {
  console.log(window.innerWidth);
  
  return (
    <NavLink to="/" style={{ textDecoration: 'none'}}>
      <StyledLogo>
          <img src={logo} alt="Broeder Julio" />
          {window.innerWidth > 289 && <h2>Broeder Julio</h2>}
      </StyledLogo>
    </NavLink>
  );
}

export default Logo;
